import {
  getRecurringTransactionSearch,
  RecurringTransactionSearchResponse,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* RecurringTransactionSearchRequest(
  self: Self,
  query: string
): Generator<Promise<FlowReturn<RecurringTransactionSearchResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRecurringTransactionSearch(query);
    const {
      RecurringProcessPaymentsWithRecurringFileApprovals,
      PaginationInfo,
      status,
    } = (response as RecurringTransactionSearchResponse).data;
    self.recurringTransaction.reset();

    if (RecurringProcessPaymentsWithRecurringFileApprovals) {
      self.recurringTransaction.list = cast(
        RecurringProcessPaymentsWithRecurringFileApprovals
      );

      self.recurringTransaction.pagination = PaginationInfo;
      return Promise.resolve(ResponseMessage.OK);
    }

    if (status?.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }

    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default RecurringTransactionSearchRequest;
